import { Callout } from '@radix-ui/themes'
import { type Fetcher } from '@remix-run/react'
import { type TFunction } from 'i18next'
import * as React from 'react'
import { RxInfoCircled } from 'react-icons/rx'

import {
	LOGIN_REDIRECTED_FORM,
	LOGIN_SEARCH_PARAMS,
} from '#app/routes/($lang)._auth.login/route-config'

/* -------------------------------------------------------------------------------------------------
 * Alert
 * -----------------------------------------------------------------------------------------------*/

type AlertProps = {
	t: TFunction<string, undefined>
	searchParams: URLSearchParams
	fetcher: Fetcher
}

const Alert: React.FC<AlertProps> = ({ t, searchParams, fetcher }) => {
	if (
		!(
			searchParams.has(LOGIN_SEARCH_PARAMS.from) || fetcher.data?.status === 200
		)
	) {
		return <></>
	}

	if (fetcher.data?.staus < 200 && fetcher.data?.staus >= 300) {
		return (
			<AlertItem color="blue">{t('alert.loginFail.description')}</AlertItem>
		)
	}

	switch (searchParams.get(LOGIN_SEARCH_PARAMS.from)) {
		case LOGIN_REDIRECTED_FORM.registration:
			return (
				<AlertItem color="blue">
					{t('alert.redirectedFromRegistration.description')}
				</AlertItem>
			)
		case LOGIN_REDIRECTED_FORM.resetPassword:
			return (
				<AlertItem color="blue">
					{t('alert.redirectedFromResetPassword.description')}
				</AlertItem>
			)
		case LOGIN_REDIRECTED_FORM.resetPasswordToken:
			return (
				<AlertItem color="blue">
					{t('alert.redirectedFromResetPasswordToken.description')}
				</AlertItem>
			)
		case LOGIN_REDIRECTED_FORM.accountVerification:
			return searchParams.has(LOGIN_SEARCH_PARAMS.verified) ? (
				<AlertItem color="blue">
					{t('alert.redirectedFromAccountVerificationVerified.description')}
				</AlertItem>
			) : (
				<AlertItem color="red">
					{t('alert.redirectedFromAccountVerification.description')}
				</AlertItem>
			)
		default:
			return <></>
	}
}
Alert.displayName = 'Alert'

/* -------------------------------------------------------------------------------------------------
 * AlertItem
 * -----------------------------------------------------------------------------------------------*/

type AlertItemProps = Omit<
	React.PropsWithoutRef<Callout.RootProps>,
	'children'
> &
	Pick<Callout.TextProps, 'children'>

const AlertItem: React.FC<AlertItemProps> = (props) => {
	const { children, ...rest } = props

	return (
		<Callout.Root {...rest}>
			<Callout.Icon>
				<RxInfoCircled />
			</Callout.Icon>
			<Callout.Text>{children}</Callout.Text>
		</Callout.Root>
	)
}
AlertItem.displayName = 'AlertItem'

/* -----------------------------------------------------------------------------------------------*/

export { type AlertProps, Alert }
